const providerLabels = {
  openai: 'OpenAI',
  gemini: 'Gemini',
  anthropic: 'Anthropic',
  openrouter: 'OpenRouter',
};

const channelTypeLabels = {
  'Channel::Whatsapp': 'WhatsApp',
  'Channel::Api': 'WhatsApp',
  'Channel::WebWidget': 'Widget do site',
  'Channel::FacebookPage': 'Messenger',
  'Channel::Instagram': 'Instagram',
  'Channel::Telegram': 'Telegram',
  'Channel::Line': 'Line',
  'Channel::Email': 'E-mail',
};

const channelTypeIcons = {
  'Channel::Whatsapp': 'i-woot-whatsapp',
  'Channel::Api': 'i-woot-whatsapp',
  'Channel::WebWidget': 'i-lucide-globe',
  'Channel::FacebookPage': 'i-woot-messenger',
  'Channel::Instagram': 'i-woot-instagram',
  'Channel::Telegram': 'i-woot-telegram',
  'Channel::Line': 'i-woot-line',
  'Channel::Email': 'i-lucide-mail',
};

export const formatProviderName = provider => {
  return providerLabels[provider] || provider;
};

export const formatChannelType = channelType => {
  return channelTypeLabels[channelType] || channelType || 'Canal';
};

export const channelTypeIcon = channelType => {
  return channelTypeIcons[channelType] || 'i-lucide-message-circle';
};
